// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, recordOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

const emailTestStatuses = objectOf({
  completed: arrayOf(string),
  processing: arrayOf(string),
  bounced: arrayOf(string),
});

const severity = objectOf({
  Critical: number,
  Moderate: number,
  Minor: number,
});

export const isEngagementGetEmailResults = objectOf({
  statuses: emailTestStatuses,
  code_analysis: recordOf({
    key: string,
    value: objectOf({
      discrepancy_counts: severity,
    }),
  }),
});
